module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.0e1a1937.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.eot
// module id = 93
// module chunks = 3